module.exports = __webpack_public_path__ + "img/goods.7c48840f.svg";